<template>
    <b-modal id="RelatoTurnoModal" hide-footer hide-header>
        <div class="rt-header">{{ editingData ? 'EDITAR RELATO DE TURNO' : 'SELECIONAR CONTEÚDO DO RELATO' }}</div>
        <div class="rt-body">
            <template v-if="editingData">
                <div class="rt-field">
                    <label class="rt-label">Título</label>
                    <input class="rt-input" v-model="localTitle" placeholder="Título do widget" />
                </div>
                <div class="rt-field">
                    <label class="rt-label">Cor do Header</label>
                    <div class="rt-color-group">
                        <label v-for="opt in colorOptions" :key="opt.value"
                            :class="['rt-color-option', { selected: localColor === opt.value }]"
                            :style="{ backgroundColor: opt.value }">
                            <input type="radio" v-model="localColor" :value="opt.value" />
                            {{ opt.label }}
                        </label>
                    </div>
                </div>
                <div class="rt-field-separator"></div>
            </template>
            <label class="rt-section-label">Conteúdo</label>
            <label v-for="tab in tabs" :key="tab.value" class="rt-option">
                <input type="checkbox" :value="tab.value" v-model="selected" />
                {{ tab.label }}
            </label>
        </div>
        <div class="rt-footer">
            <button class="rt-btn-cancel" @click="cancel">CANCELAR</button>
            <button class="rt-btn-continue" @click="confirm" :disabled="selected.length === 0">
                {{ editingData ? 'SALVAR' : 'CONTINUAR' }}
            </button>
        </div>
    </b-modal>
</template>

<script>
export default {
    name: 'RelatoTurnoModal',
    props: {
        editingData: { type: Object, default: null }
    },
    data() {
        return {
            selected: [],
            localTitle: '',
            localColor: '#333',
            tabs: [
                { value: 'relatos', label: 'Relatos' },
                { value: 'producao', label: 'Indicadores de Performance' },
                { value: 'manutencao', label: 'Notas de Manutenção' },
                { value: 'moagem', label: 'Redução de Moagem' }
            ],
            colorOptions: [
                { value: '#000000', label: 'Preto' },
                { value: '#26806c', label: 'Verde' },
                { value: '#70297A', label: 'Roxo' },
                { value: '#254E70', label: 'Azul' },
                { value: '#808080', label: 'Cinza' },
                { value: '#bf0603', label: 'Vermelho' },
                { value: '#f6ae2d', label: 'Amarelo' },
                { value: '#e85933', label: 'Laranja' }
            ]
        };
    },
    watch: {
        editingData(val) {
            if (val) {
                this.localTitle = val.title || '';
                this.localColor = val.color || '#333';
                this.selected = val.tabs ? [...val.tabs] : [];
            } else {
                this.reset();
            }
        }
    },
    methods: {
        reset() {
            this.selected = [];
            this.localTitle = '';
            this.localColor = '#333';
        },
        cancel() {
            this.reset();
            this.$bvModal.hide('RelatoTurnoModal');
        },
        confirm() {
            if (this.selected.length === 0) return;
            this.$emit('confirm', {
                tabs: [...this.selected],
                title: this.localTitle,
                color: this.localColor
            });
            this.reset();
            this.$bvModal.hide('RelatoTurnoModal');
        }
    }
};
</script>

<style scoped>
.rt-header {
    padding: 14px 18px;
    border-bottom: 1px solid #eee;
    font-weight: bold;
    font-size: 13px;
    color: #333;
    text-transform: uppercase;
}
.rt-body {
    padding: 24px 32px;
    display: flex;
    flex-direction: column;
    gap: 14px;
}
.rt-field {
    display: flex;
    flex-direction: column;
    gap: 6px;
}
.rt-label {
    font-size: 12px;
    font-weight: 600;
    color: #555;
    text-transform: uppercase;
    margin: 0;
}
.rt-section-label {
    font-size: 12px;
    font-weight: 600;
    color: #555;
    text-transform: uppercase;
    margin: 0;
}
.rt-input {
    border: 1px solid #009a9a;
    border-radius: 4px;
    padding: 6px 8px;
    font-size: 14px;
    outline: none;
}
.rt-input:focus {
    box-shadow: 0 0 0 0.2rem rgba(0,154,154,0.25);
}
.rt-color-group {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}
.rt-color-option {
    display: flex;
    align-items: center;
    padding: 6px 10px;
    border-radius: 6px;
    cursor: pointer;
    color: #fff;
    font-weight: 500;
    font-size: 12px;
    transition: transform 0.15s, box-shadow 0.15s;
    border: 2px solid transparent;
    margin: 0;
}
.rt-color-option input[type="radio"] {
    margin-right: 6px;
}
.rt-color-option:hover {
    transform: translateY(-1px);
    box-shadow: 0 3px 6px rgba(0,0,0,0.15);
}
.rt-color-option.selected {
    border-color: #009a9b;
    box-shadow: none;
}
.rt-field-separator {
    border-top: 1px solid #eee;
    margin: 4px 0;
}
.rt-option {
    display: flex;
    align-items: center;
    gap: 12px;
    font-size: 14px;
    color: #444;
    cursor: pointer;
    margin: 0;
}
.rt-option input[type="checkbox"] {
    width: 17px;
    height: 17px;
    accent-color: #f37021;
    cursor: pointer;
}
.rt-footer {
    padding: 12px 18px;
    border-top: 1px solid #eee;
    display: flex;
    justify-content: flex-end;
    gap: 10px;
}
.rt-btn-cancel {
    background: #fff;
    color: #f37021;
    border: 1px solid #f37021;
    padding: 9px 24px;
    border-radius: 4px;
    font-weight: bold;
    cursor: pointer;
    font-size: 12px;
    text-transform: uppercase;
}
.rt-btn-continue {
    background: #f37021;
    color: #fff;
    border: none;
    padding: 9px 24px;
    border-radius: 4px;
    font-weight: bold;
    cursor: pointer;
    font-size: 12px;
    text-transform: uppercase;
}
.rt-btn-continue:disabled { opacity: 0.5; cursor: not-allowed; }
</style>
